import { createSelector } from "reselect";

const selectPayments = (state) => state.payments;

export const selectAllTransactions = createSelector([selectPayments], (payments) => payments?.transactions || {});
